export const BRAND_TITLE_SUFFIX = " | Whoppah";

/*
 * A trailing "| Whoppah" in any spelling editors have used: optional spaces
 * around the pipe, any casing, trailing whitespace. Strapi listing-page
 * `seo.title` values often carry it already (WHO-5543: 90 of 97 vintage
 * style pages), while the `<SEO>` component appends the same suffix.
 */
const TRAILING_BRAND_SUFFIX = /\s*\|\s*whoppah\s*$/i;

export const hasBrandSuffix = (title: string): boolean =>
  TRAILING_BRAND_SUFFIX.test(title);

/** Removes a trailing "| Whoppah" so callers can append their own parts first. */
export const stripBrandSuffix = (title: string): string =>
  title.replace(TRAILING_BRAND_SUFFIX, "").trimEnd();

/**
 * Document title with exactly one " | Whoppah" suffix. Titles that already end
 * with the brand keep it (normalised to the canonical spelling); titles without
 * it get it appended; an empty title stays empty so the caller can skip the tag.
 */
export const withBrandSuffix = (title: string | null | undefined): string => {
  const base = stripBrandSuffix((title ?? "").trim());

  return base ? `${base}${BRAND_TITLE_SUFFIX}` : "";
};
